import { render, staticRenderFns } from "./research-index.vue?vue&type=template&id=ca4e5118&"
import script from "./research-index.vue?vue&type=script&lang=js&"
export * from "./research-index.vue?vue&type=script&lang=js&"
import style0 from "./research-index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports